import { urlApi } from '../../config'
import { getAccessToken } from '../../auth'

const request = async (transactionId, options) => {
  try {
    const token = await getAccessToken()
    const response = await fetch(
      `${urlApi}/admin/transactions/refund-remainder/${encodeURIComponent(transactionId)}`,
      {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          ...(typeof token === 'string' && { Authorization: `Bearer ${token}` })
        },
        ...options
      }
    )
    const data = await response.json().catch(() => null)
    return { ok: response.ok, status: response.status, data }
  } catch (error) {
    console.error(error)
    return { ok: false, status: 0, data: null }
  }
}

export const fetchRemainder = transactionId => request(transactionId, { method: 'GET' })

export const refundRemainder = (transactionId, driverShare) =>
  request(transactionId, {
    method: 'POST',
    body: JSON.stringify(driverShare ? { driver_share: driverShare } : {})
  })
